import { BaseService } from '../../../infra/base.service'
import type { Partner } from './partner.entity'
import type { PartnersRepository } from './partners.repository'

export class PartnersService extends BaseService<Partner> {
    constructor(private rep: PartnersRepository) {
        super(rep)
    }
}
